import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-lock-closed-icon',
  templateUrl: 'lock-closed-icon.component.html'
})
export class LockClosedIconComponent {
  constructor() {}
}
